import { MenuLinkItem, MenuLinkItemProps } from '@creditornot/cb-menu';
import React from 'react';
import { useHistory } from 'react-router-dom';

type Props = MenuLinkItemProps;

const isModifiedEvent = (event: React.MouseEvent<HTMLAnchorElement>) =>
  !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);

/**
 * This is a wrapper for the MenuLinkItem in `cb-menu` to work with react-router-dom.
 * Reference link component implementation: https://github.com/ReactTraining/react-router/blob/master/packages/react-router-dom/modules/Link.js
 *
 * You should provide `href` to navigate. `onClick` you should use only if there's additional stuff to do, such as closing a popover.
 */
const MenuLinkItemRRD = React.forwardRef<HTMLAnchorElement, Props>(
  ({ href, children, onClick, target, ...rest }, ref) => {
    const history = useHistory();

    return (
      <MenuLinkItem
        href={href}
        target={target}
        onClick={event => {
          try {
            if (onClick) {
              onClick(event);
            }
          } catch (ex) {
            event.preventDefault();
            throw ex;
          }

          if (
            href !== undefined &&
            !event.defaultPrevented && // onClick prevented default
            event.button === 0 && // ignore everything but left clicks
            (!target || target === '_self') && // let browser handle "target=_blank" etc.
            !isModifiedEvent(event) // ignore clicks with modifier keys
          ) {
            event.preventDefault();
            history.push(href);
          }
        }}
        ref={ref}
        {...rest}
      >
        {children}
      </MenuLinkItem>
    );
  },
);

export default MenuLinkItemRRD;
